<script setup lang="ts">
import { defineAsyncComponent, computed } from "vue";
import { container } from "tsyringe";

// adapter
import type { ClientStateManager } from "@/shared/types/adapter/client-interface";

// instance
const modalSecondLayerManager =
    container.resolve<ClientStateManager.ModalSecondLayerManager>("ModalSecondLayerManager");

const modalState = modalSecondLayerManager.getState();

const component = computed(() => {
    const modalLayoutPath = modalState.modalLayout;
    return defineAsyncComponent(() => import(`./container/${modalLayoutPath}.vue`));
});

const closeModal = () => {
    modalSecondLayerManager.dispatch("unmountModal");
};
</script>

<template>
    <Teleport to="body" v-if="modalState.modalOpen">
        <div
            class="fixed top-0 left-0 flex items-center justify-center w-full shadow-md xl:h-full h-lvh bg-primary-black/30 z-1000"
            @click.self="closeModal"
        >
            <div
                class="flex items-center justify-center w-full h-auto sm:w-fit z-1000"
                tabindex="-1"
            >
                <Transition name="fade">
                    <component :is="component" />
                </Transition>
            </div>
        </div>
    </Teleport>
</template>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: all 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(-20px);

    opacity: 0;
}
</style>
